"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.millisecondsToSeconds = millisecondsToSeconds;
exports.secondsToHours = secondsToHours;
exports.millisecondsToHours = millisecondsToHours;
exports.hoursToSeconds = hoursToSeconds;
exports.eurosToCents = eurosToCents;
exports.centsToEuros = centsToEuros;
exports.percentToFactor = percentToFactor;
exports.factorToPercent = factorToPercent;
exports.getRate = getRate;
exports.multiplyWithRate = multiplyWithRate;
exports.multiplyWithFactor = multiplyWithFactor;
exports.multiplyWithPercent = multiplyWithPercent;
exports.add = add;
exports.sum = sum;
exports.subtract = subtract;
exports.round = round;
exports.min = min;
exports.max = max;
function millisecondsToSeconds(milliseconds) {
    return (milliseconds / 1000);
}
function secondsToHours(seconds) {
    return (seconds / 60 / 60);
}
function millisecondsToHours(seconds) {
    return (seconds / 60 / 60 / 1000);
}
function hoursToSeconds(hours) {
    return round(hours * 60 * 60);
}
function eurosToCents(euros) {
    return round(euros * 100);
}
function centsToEuros(cents) {
    return (cents / 100);
}
function percentToFactor(percent) {
    return (percent / 100);
}
function factorToPercent(factor) {
    return (factor * 100);
}
function getRate(a, b) {
    return (b === 0 ? 0 : a / b);
}
function multiplyWithRate(value, rate) {
    return (value * rate);
}
function multiplyWithFactor(value, factor) {
    return (value * factor);
}
function multiplyWithPercent(value, percent) {
    return (value * percentToFactor(percent));
}
function add(first, second) {
    return ((first !== null && first !== void 0 ? first : 0) + (second !== null && second !== void 0 ? second : 0));
}
function sum(...values) {
    return values.reduce((total, value) => total + value, 0);
}
function subtract(first, ...values) {
    return (first - values.reduce((total, value) => total + value, 0));
}
function round(value, decimals = 0) {
    const factor = Math.pow(10, decimals);
    return (Math.round(value * factor) / factor);
}
function min(first, ...values) {
    return Math.min(first, ...values);
}
function max(first, ...values) {
    return Math.max(first, ...values);
}
//# sourceMappingURL=units.js.map